import { each, find, go, map, sum } from 'fxjs/es';
import { UtilLangB } from '../../../../Util/Lang/B/Function/module/UtilLangB.js';
import { OMPProductListConstantS } from '../../S/Constant/module/OMPProductListConstantS.js';

export const getBpFilters = async (query) => {
  const cate_list_id = parseInt(query.cate_list_id);
  const cate_item_id = parseInt(query.cate_item_id);

  const where_sql = SQL`${CL(UtilLangB.col('bp.is_use'))}=true${
    cate_list_id ? SQL` AND bp.cate_list_id=${cate_list_id}` : EMPTY
  } ${cate_item_id ? SQL` AND bp.cate_item_id=${cate_item_id}` : EMPTY} AND bp.is_hidden=false`;

  const [brand_filter, color_filter, size_filter, filter_lists] = await Promise.all([
    go(
      R.QUERY`
      SELECT 
        c.id, c.no, ${CL(UtilLangB.colAs('c.name'))}, c.type
      FROM base_products bp
      INNER JOIN categories c
      ON bp.brand_filter_id=c.id
      WHERE 
        ${where_sql} AND
        c.type='bp_brand_filters' AND
        c.is_public=true AND
        c.is_hidden=false 
      GROUP BY 1
      ORDER BY 2, 1;`,
      map((fi) => {
        return {
          ...fi,
          filter_list_id: 'brand',
        };
      }),
      (filter_items) => {
        if (filter_items.length == 1 && filter_items[0].id == OMPProductListConstantS.OTHER_BRAND_ID) {
          return [];
        } else {
          return filter_items;
        }
      },
      (filter_items) => {
        return {
          id: 'brand',
          name: TT('product::list::list_1_1'),
          no: -9999,
          _: { filter_items },
        };
      },
    ),
    go(
      R.QUERY`
      SELECT
        c.id, c.no, ${CL(UtilLangB.colAs('c.name'))}, c.name2 color_code, c.type
      FROM categories c
      INNER JOIN base_product_colors bc
        ON c.id=bc.color_filter_id
      INNER JOIN base_products bp
        ON bp.id=bc.base_product_id 
      WHERE
        ${where_sql} AND 
        bc.is_public AND
        bc.is_hidden=false AND
        c.type='bp_color_filters' AND
        c.is_public=true AND
        c.is_hidden=false
      GROUP BY 1
      ORDER BY 2, 1;`,
      map((fi) => {
        return {
          ...fi,
          filter_list_id: 'color',
        };
      }),
      (filter_items) => {
        return {
          id: 'color',
          name: TT('product::list::list_2_1'),
          no: -9998,
          _: { filter_items },
        };
      },
    ),
    go(
      R.QUERY`
      SELECT
        c.id, c.no, ${CL(UtilLangB.colAs('c.name'))}, c.type
      FROM categories c
      INNER JOIN base_product_sizes bs
        ON c.id=bs.size_filter_id
      INNER JOIN base_products bp
        ON bp.id=bs.base_product_id
      WHERE 
        ${where_sql} AND
        bs.is_public AND
        bs.is_hidden=false AND
        c.type='bp_size_filters' AND
        c.is_public=true AND
        c.is_hidden=false
      GROUP BY 1
      ORDER BY 2, 1;`,
      map((fi) => {
        return {
          ...fi,
          filter_list_id: 'size',
        };
      }),
      (filter_items) => {
        return {
          id: 'size',
          name: TT('product::list::list_3_1'),
          no: -9997,
          _: { filter_items },
        };
      },
    ),
    go(
      RR.ASSOCIATE`
      filter_lists ${{
        column: CL('id', 'no', UtilLangB.colAs('name')),
        query: SQL`
          WHERE is_hidden=false AND is_public AND id IN (
            SELECT filter_list_id
            FROM bp_filter_lists bfl
            INNER JOIN base_products bp
              ON bfl.base_product_id=bp.id
            WHERE ${where_sql}
          )  ORDER BY no, id`,
      }}
        < filter_items ${{
          column: CL('id', 'no', UtilLangB.colAs('name')),
          query: SQL`
            WHERE is_hidden=false AND is_public AND id IN (
              SELECT bflfi.filter_item_id
              FROM bp_filter_list_filter_items bflfi
              INNER JOIN bp_filter_lists bfl
                ON bflfi.bp_filter_list_id=bfl.id
              INNER JOIN base_products bp
                ON bfl.base_product_id=bp.id
              WHERE ${where_sql}
            ) ORDER BY no, id`,
        }}`,
      (filter_lists) => {
        /*
         * 가격대 해외에서는 안나오게 하드코딩
         * */
        if (
          T.lang != 'kr' &&
          OMPProductListConstantS.HIDE_RANGE_CATE_LIST_FOR_EN_JP_IDS.includes(cate_list_id)
        ) {
          return filter_lists.filter(({ id }) => {
            return id != OMPProductListConstantS.PRICE_RANGE_FILTER_LIST_ID;
          });
        } else {
          return filter_lists;
        }
      },
    ),
  ]);

  each(
    (fl) => {
      fl.count = 0;
      each((f) => {
        const checked = !!find((id) => id == f.id, query[`f_${fl.id}`]);
        if (checked) fl.count++;
        f.checked = checked;
      }, fl._.filter_items);
    },
    [brand_filter, color_filter, size_filter, ...filter_lists],
  );

  const total_count = sum(
    [brand_filter, color_filter, size_filter, ...filter_lists].map(({ count }) => {
      return count;
    }),
  );

  return { total_count, brand_filter, color_filter, size_filter, filter_lists };
};
